// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6cedda18","952":"98416e2c"}[chunkId] + ".chunk.js";
};